import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { Grid, Header, Dropdown, Image, Modal, Button, Icon, Dimmer, Loader } from "semantic-ui-react";
import AvatarEditor from "react-avatar-editor";

import Form from "../utils/Form";

import { logoutUser, changeCurrentUserAvatar } from "../../store/user";
import { generateInput } from "../utils/misc";

class UserPanel extends Component {
    state = { modalOpen: false, previewImage: "", croppedImage: "", blob: "", uploading: false };

    fields = [
        generateInput({
            name: "avatar",
            type: "file",
            element: "file",
            label: "new avatar",
            avatarImage: true,
            formNoValidate: true,
        }),
    ];

    dropdownOptions = () => [
        {
            key: "user",
            text: (
                <span>
                    signed in as <strong>{this.props.currentUser?.displayName}</strong>
                </span>
            ),
            disabled: true,
        },
        {
            key: "avatar",
            text: (
                <span className="action" onClick={this.openModal}>
                    Change Avatar
                </span>
            ),
        },
        {
            key: "signInOutAction",
            text: this.props.currentUser ? (
                <span className="action" onClick={this.props.logoutUser}>
                    log out
                </span>
            ) : (
                <span className="action">
                    <Link to="/login">log in</Link>
                </span>
            ),
        },
    ];

    openModal = () => this.setState({ modalOpen: true });

    closeModal = () => this.setState({ modalOpen: false, previewImage: "", croppedImage: "", blob: "", uploading: false });

    handleCroppedImage = () => {
        if (!this.avatarEditor) return;

        this.avatarEditor.getImageScaledToCanvas().toBlob(blob => {
            this.setState({ croppedImage: window.URL.createObjectURL(blob), blob });
        });
    };

    onChange = ({ avatar: { file } }) => file && this.setState({ previewImage: file });

    onSubmit = async formValues => {
        const { changeCurrentUserAvatar, currentUser } = this.props;
        const { blob } = this.state;

        this.setState({ uploading: true });

        await changeCurrentUserAvatar(
            { blob, metadata: { contentType: "image/jpeg" } },
            `avatars/user/${currentUser.uid}`,
        );

        this.setState({ uploading: false });

        this.closeModal();
    };

    render() {
        const { modalOpen, previewImage, croppedImage, uploading } = this.state;
        const { currentUser } = this.props;

        return (
            <Grid className="user-panel">
                <Grid.Column>
                    <Grid.Row>
                        <Header inverted as="h2" className="logo">
                            <svg
                                width="54"
                                height="54"
                                className="c-nav--footer__svgicon c-slackhash"
                                viewBox="0 0 54 54"
                                xmlns="http://www.w3.org/2000/svg">
                                <g fill="none" fillRule="evenodd">
                                    <path
                                        d="M19.712.133a5.381 5.381 0 0 0-5.376 5.387 5.381 5.381 0 0 0 5.376 5.386h5.376V5.52A5.381 5.381 0 0 0 19.712.133m0 14.365H5.376A5.381 5.381 0 0 0 0 19.884a5.381 5.381 0 0 0 5.376 5.387h14.336a5.381 5.381 0 0 0 5.376-5.387 5.381 5.381 0 0 0-5.376-5.386"
                                        fill="#36C5F0"></path>
                                    <path
                                        d="M53.76 19.884a5.381 5.381 0 0 0-5.376-5.386 5.381 5.381 0 0 0-5.376 5.386v5.387h5.376a5.381 5.381 0 0 0 5.376-5.387m-14.336 0V5.52A5.381 5.381 0 0 0 34.048.133a5.381 5.381 0 0 0-5.376 5.387v14.364a5.381 5.381 0 0 0 5.376 5.387 5.381 5.381 0 0 0 5.376-5.387"
                                        fill="#2EB67D"></path>
                                    <path
                                        d="M34.048 54a5.381 5.381 0 0 0 5.376-5.387 5.381 5.381 0 0 0-5.376-5.386h-5.376v5.386A5.381 5.381 0 0 0 34.048 54m0-14.365h14.336a5.381 5.381 0 0 0 5.376-5.386 5.381 5.381 0 0 0-5.376-5.387H34.048a5.381 5.381 0 0 0-5.376 5.387 5.381 5.381 0 0 0 5.376 5.386"
                                        fill="#ECB22E"></path>
                                    <path
                                        d="M0 34.249a5.381 5.381 0 0 0 5.376 5.386 5.381 5.381 0 0 0 5.376-5.386v-5.387H5.376A5.381 5.381 0 0 0 0 34.25m14.336-.001v14.364A5.381 5.381 0 0 0 19.712 54a5.381 5.381 0 0 0 5.376-5.387V34.25a5.381 5.381 0 0 0-5.376-5.387 5.381 5.381 0 0 0-5.376 5.387"
                                        fill="#E01E5A"></path>
                                </g>
                            </svg>
                            <Header.Content>DevChat</Header.Content>
                        </Header>

                        <Header as="h4" inverted>
                            <Dropdown
                                trigger={
                                    <span>
                                        <Image src={currentUser?.photoURL} spaced="right" avatar />
                                        {currentUser?.displayName}
                                    </span>
                                }
                                options={this.dropdownOptions()}
                                className="dropdown"
                            />
                        </Header>
                    </Grid.Row>

                    <Modal basic open={modalOpen} onClose={this.closeModal} className="change-avatar--modal">
                        <Modal.Header className="title">
                            <h2>Change Avatar</h2>
                        </Modal.Header>

                        <Modal.Content>
                            <div className="form-container">
                                <div className="form-wrapper">
                                    <Form
                                        form="changeAvatarForm"
                                        fields={this.fields}
                                        onSubmit={this.onSubmit}
                                        onChange={this.onChange}>
                                        <div className="image-preview-container">
                                            {uploading && (
                                                <Dimmer active inverted>
                                                    <Loader size="big" inverted />
                                                </Dimmer>
                                            )}

                                            <div>
                                                {previewImage && (
                                                    <AvatarEditor
                                                        image={previewImage}
                                                        border={50}
                                                        scale={1.2}
                                                        ref={node => (this.avatarEditor = node)}
                                                        disableCanvasRotation
                                                    />
                                                )}
                                            </div>

                                            <div>{croppedImage && <Image src={croppedImage} />}</div>
                                        </div>

                                        <Modal.Actions>
                                            {croppedImage && (
                                                <Button inverted type="submit">
                                                    <Icon name="save" /> change avatar
                                                </Button>
                                            )}

                                            <Button
                                                inverted
                                                className="preview-btn"
                                                type="button"
                                                onClick={this.handleCroppedImage}>
                                                <Icon name="image" /> preview
                                            </Button>

                                            <Button color="red" inverted onClick={this.closeModal}>
                                                <Icon name="remove" /> cancel
                                            </Button>
                                        </Modal.Actions>
                                    </Form>
                                </div>
                            </div>
                        </Modal.Content>
                    </Modal>
                </Grid.Column>
            </Grid>
        );
    }
}

export default connect(null, { logoutUser, changeCurrentUserAvatar })(UserPanel);
